// extracted by mini-css-extract-plugin
export var active = "_2r-9";
export var backButton = "_2r-8";
export var clone = "_2r-e";
export var collapseBar = "_2r-j";
export var collapseMode = "_2r-l";
export var collapsed = "_2r-n";
export var dragHandle = "_2r-c";
export var dropdownIcon = "_2r-g";
export var expanding = "_2r-m";
export var hidden = "_2r-w";
export var iconContainer = "_2r-p";
export var iconSwapper = "_2r-v";
export var navItem = "_2r-6";
export var navItemIcon = "_2r-f";
export var navProfile = "_2r-7";
export var notificationCountBadge = "_2r-i";
export var notificationDot = "_2r-q";
export var optionsContainer = "_2r-h";
export var primaryNav = "_2r-0";
export var primaryNavDivider = "_2r-u";
export var primaryNavResizeHandle = "_2r-2";
export var primaryNavResizing = "_2r-1";
export var primaryNavTabSection = "_2r-t";
export var primaryTab = "_2r-o";
export var primaryTabIconBox = "_2r-r";
export var secondaryNav = "_2r-3";
export var selected = "_2r-s";
export var settingsNav = "_2r-4";
export var settingsNavItems = "_2r-5";
export var show = "_2r-d";
export var sideNav = "_2r-k";
export var teamItem = "_2r-a";
export var userProfileItem = "_2r-b";